export default "__VITE_ASSET__CpnmRNgV__"